<template>
  <van-popup v-model="popShow" position="bottom" :close-on-click-overlay="false">
    <div class="filter_popup">
      <img
        :class="$store.state.isMirroring && 'mirror'"
        class="close"
        src="@/assets/close.png"
        @click="popShow = false"
      />
      <div class="title">{{ $t('filters.amount') }}</div>
      <div v-if="popShow" class="input_group">
        <CommonInput
          class="amount_input"
          v-model="minAmount"
          :placeholder="$t('filters.minimum')"
          theme="white"
          inputmode="numeric"
          auto-focus
        >
          <template #prefix>
            <div class="prefix">$</div>
          </template>
        </CommonInput>
        <div class="split"></div>
        <CommonInput
          class="amount_input"
          v-model="maxAmount"
          :placeholder="$t('filters.maximum')"
          theme="white"
          inputmode="numeric"
        >
          <template #prefix>
            <div class="prefix">$</div>
          </template>
        </CommonInput>
      </div>
      <div class="bottom_btn_group">
        <div class="bottom_btn cancel" @click="resetAmount">{{ $t('filters.reset') }}</div>
        <div class="bottom_btn confirm" @click="setAmount">{{ $t('common.confirm') }}</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import CommonInput from '@/components/CommonInput.vue'

export default {
  name: 'TransactionAmountFilter',
  components: {
    CommonInput
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    curMinAmount: {
      type: String,
      default: ''
    },
    curMaxAmount: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      popShow: false,
      minAmount: '',
      maxAmount: ''
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      if (val) {
        this.minAmount = this.curMinAmount
        this.maxAmount = this.curMaxAmount
      }
    },
    popShow(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    resetAmount() {
      this.minAmount = ''
      this.maxAmount = ''
    },
    setAmount() {
      this.$emit('setAmount', { minAmount: this.minAmount, maxAmount: this.maxAmount })
      this.popShow = false
    }
  }
}
</script>

<style scoped>
.filter_popup {
  width: 100%;
  padding: 0.24rem 0.2rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
}

.close.mirror {
  left: 0.24rem;
  right: auto;
}

.title {
  width: 100%;
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
}

.input_group {
  margin-top: 0.12rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.prefix {
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  margin-inline-end: 0.08rem;
}

.split {
  width: 0.13rem;
  height: 0.02rem;
  background: #2f2f2f;
  margin: 0 0.2rem;
  flex-shrink: 0;
}

.bottom_btn_group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.48rem;
}

.bottom_btn {
  display: flex;
  width: 100%;
  padding: 0.13rem 0.24rem;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  border-radius: 0.08rem;
  border: 0.01rem solid #3fbb70;
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.16rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.24rem;
}

.bottom_btn.cancel {
  margin-inline-end: 0.12rem;
}

.bottom_btn.confirm {
  background: #3fbb70;
  color: #fff;
}
</style>

<style>
.amount_input.focus .input_area {
  color: #3fbb70;
}

.amount_input.focus .prefix {
  color: #3fbb70;
}
</style>



// WEBPACK FOOTER //
// src/components/Transaction/TransactionAmountFilter.vue